<template>
    <v-layout row wrap class="mt-2">
        <v-flex xs4 offset-xs1>
            <choose-appearance-constrain
                    v-model="type"/>
        </v-flex>
        <v-flex xs12>
            <DataTable
                    v-redirect-if-no-permission:SERVICES
                    v-if="name"
                    :url="api.ACTIONS.SERVICE_LOCATIONS(id)"
                    descending
                    :initial-url-search-params="params"
                    :fields-hidden-main="['radius','polygon','centroid','deleted_at','created_at','updated_at','type','pivot']"
                    :fields-hidden-add="['id','name','radius','polygon','centroid','deleted_at','created_at','updated_at','type','pivot']"
                    :titles="titles"
                    :title='name + " - Attached Locations"'
                    :enable-edit="false"
                    :enable-delete="false"
                    :fields-extra-add="fieldsExtraAdd"
                    force-reload
                    :selected-actions="selectedActions"
                    :selectable="'Select'"
                    :formatter="formatter"
                    :delete-extra-data="{type}"
                    :post-extra-data="{type}"
                    :edit-extra-data="{type}"
            ></DataTable>
        </v-flex>
    </v-layout>
</template>

<script>
    import DataTable from "@/components/wasilni/DataTable";
    import ChooseAppearanceConstrain from "@/components/wasilni/input/ChooseAppearanceConstrain";

    export default {
        name: "ServiceLocations",
        title: 'Locations',
        components: {ChooseAppearanceConstrain, DataTable},
        data() {
            return {
                id: null,
                name: null,
                type: null
            }
        },
        mounted() {
            this.id = this.$route.params.id;
            this.name = this.$route.query.name || "Unknown";
            this.type = this.$route.query.appearance_constrain || 'BLACKLIST';
        },
        computed: {
            params() {
                const params = new URLSearchParams();
                params.append("type", this.type);
                return params;
            },
            formatter() {
                const api = this.api;
                return {

                }
            },
            titles() {
                return {
                    id: "#",
                    locations: "Locations To Add"
                }
            },
            fieldsExtraAdd() {
                return {
                    locations: "choose-locations"
                }
            },
            selectedActions() {
                return {
                    "Delete": {
                        color: "error",
                        title: "Delete",
                        do: async (items) => {
                            try {
                                let params = new URLSearchParams();
                                let index = 0;
                                params.append("type", this.type);
                                for (let item of items) params.append("locations[" + (index++) + "]", item.id);
                                await this.axios.delete(this.api.ACTIONS.SERVICE_LOCATIONS(this.id) + "?" + params.toString());
                                window.getApp.$emit("SHOW_TOAST", "Deleted", "green");
                                return {
                                    shouldClearSelected: true,
                                    shouldReloadData: true
                                }
                            } catch (e) {
                                window.getApp.$emit("SHOW_TOAST", "Failed!", "red");
                            }

                        }
                    }
                }
            }
        }
    }
</script>

<style scoped>

</style>
